import { z } from 'zod'
import { FormFields } from '@App/forms/v2/common/form-field'
import { CheckboxSize } from '@App/enum/checkbox-size'
import { FormFieldTypes } from '@App/enum/form-field-types'
import populateSchema from '@App/forms/v2/helpers/populate-schema'

const termsAndConditionsKey = 'termsAndConditions'
const privacyPolicyKey = 'privacyPolicy'
const searchTermsAndConditionsKey = 'searchTermsAndConditions'
const showWelcomePopupKey = 'showWelcomePopup'
const mfaBySmsKey = 'mfaBySms'
const mfaByEmailKey = 'mfaByEmail'
const showDetailedWorkCardsKey = 'showDetailedWorkCards'

const settingsFormKey = 'settingsForm'
const settingsSchema = z.object({
    [termsAndConditionsKey]: z.boolean(),
    [privacyPolicyKey]: z.boolean(),
    [searchTermsAndConditionsKey]: z.boolean(),
    [showWelcomePopupKey]: z.boolean(),
    [mfaBySmsKey]: z.boolean(),
    [mfaByEmailKey]: z.boolean(),
    [showDetailedWorkCardsKey]: z.boolean(),
})

type SettingsType = z.infer<typeof settingsSchema>

type SettingsFormFieldsType = Omit<
    SettingsType,
    'searchTermsAndConditions' | 'showWelcomePopup' | 'mfaBySms' | 'mfaByEmail' | 'showDetailedWorkCards'
>

const settingsFieldsNoSchema: FormFields<SettingsFormFieldsType> = {
    [termsAndConditionsKey]: {
        name: termsAndConditionsKey,
        parentObjectName: settingsFormKey,
        label: 'Accept',
        size: CheckboxSize.small,
        checked: false,
        type: FormFieldTypes.CHECKBOX,
    },
    [privacyPolicyKey]: {
        name: privacyPolicyKey,
        parentObjectName: settingsFormKey,
        label: 'Accept',
        size: CheckboxSize.small,
        checked: false,
        type: FormFieldTypes.CHECKBOX,
    },
}

const settingsFormFields: FormFields<SettingsFormFieldsType> = populateSchema(settingsFieldsNoSchema, settingsSchema)

export { settingsFormFields, settingsSchema, SettingsType, settingsFormKey }
